import React, { useState, useEffect } from 'react'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import { ExpandMore as ExpandMoreIcon } from '@material-ui/icons'

import useStyles from '../style'
import Typography from '../../../../atoms/display/typography'

import { setScriptExpanded } from '../../../../../redux/script/actions'
import ScriptChildItem from './ScriptChildAccordion'

function ScriptCategoryItem({
  category,
  key,
  scriptContent,
  triggerExpanded,
  setEnterDescription,
  ...props
}) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const { favorites } = useSelector((state) => state.favoriteScripts)
  const script = useSelector((state) => state.script)
  const activeConversation = useSelector((state) => state.activeConversation)
  const keyword = useSelector(
    (state) => state.faq?.keyword?.[activeConversation]
  )

  const [expanded, setExpanded] = useState(
    !!script?.expanded?.[activeConversation]?.[category]
  )

  const handleExpanded = (isExpanded) => {
    setExpanded(isExpanded)
    dispatch(setScriptExpanded(activeConversation, category, isExpanded))
  }

  useEffect(() => {
    if (!expanded && !!keyword) setExpanded(true)
  }, [triggerExpanded])

  return (
    <Accordion
      onChange={() => {
        handleExpanded(!expanded)
      }}
      expanded={expanded}
      className={classes.accordion}
      key={key}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{ color: '#009ee2' }} />}
        id="Panel"
        className={classes.accordionParent}
      >
        <Typography>{category}</Typography>
      </AccordionSummary>
      <AccordionDetails style={{ display: 'block' }}>
        {scriptContent
          ?.filter((el) =>
            category === t('faqs.category.notfound')
              ? !el.categories
              : el.categories?.includes(category)
          )
          .map((scriptChild, subKey) => {
            let remove = false
            if (favorites?.length >= 0 && favorites !== undefined) {
              remove = favorites?.includes(scriptChild.id)
            }
            return (
              <ScriptChildItem
                category={category}
                key={key}
                scriptChild={scriptChild}
                remove={remove}
                subKey={subKey}
              />
            )
          })}
      </AccordionDetails>
    </Accordion>
  )
}

export default React.memo(ScriptCategoryItem)
